import { ButtonPrimary, Input, typographyRem } from '@by-miles/bymiles-styles'
import { vehicleReg } from '@by-miles/regex'
import React from 'react'

import { AccessibleFormWrapper } from '../../../AccessibleFormWrapper'
import { ToolTip } from '../../../ToolTip'
import { EnterRegistrationStyle } from './EnterRegistrationStyle'
const { h4: H4 } = typographyRem

interface EnterRegistrationProps {
  registrationNumber: string
  regError: string
  handleFindReg: () => void
  handleSetReg: (value: string) => void
  createQuoteLoading: boolean
  changeVehicleLoading: boolean
}

export const EnterRegistration = ({
  registrationNumber,
  regError,
  handleFindReg,
  handleSetReg,
  createQuoteLoading,
  changeVehicleLoading,
}: EnterRegistrationProps) => {
  return (
    <EnterRegistrationStyle>
      <div className="question-text-container">
        <H4 className="enter-reg-heading">Enter your registration number.</H4>
      </div>
      <AccessibleFormWrapper className="enter-reg-wrapper" onSubmit={handleFindReg}>
        <Input
          placeHolder="Your reg"
          name="reg"
          value={registrationNumber}
          onChange={handleSetReg}
          error={regError}
          keepLabel={false}
          dataCy="reg-input-text-field"
          valid={!!registrationNumber?.match(vehicleReg)}
          className="reg-input"
        />
        <div className="button-tooltip-container">
          <ButtonPrimary
            dataCy="find-car-button"
            iconRight="IconArrowRight"
            label="Find my car"
            className="reg-button"
            loading={createQuoteLoading || changeVehicleLoading}
          />
          <ToolTip
            text="We need the registration number of the car you want to insure to get you a quote and to check whether it's compatible with our Miles Tracker or Connect policies. If you don't know your number plate, unfortunately we won't be able to get you a quote just yet."
            className="reg-tool-tip"
          />
        </div>
      </AccessibleFormWrapper>
    </EnterRegistrationStyle>
  )
}
